export const createCustomer = `
    mutation createCustomer($input: CreateCustomerInput!) {
        createCustomer(input:$input) {
            id
            name
            description      
            status 
            contactInfo {
              email
              phone
              website
            }
            created
            createdByUsername
            createdByUser {
                name
                givenName
                familyName
                email
            }
    }
}`;

export const updateCustomer = `
    mutation updateCustomer($input: UpdateCustomerInput!) {
        updateCustomer(input:$input){
            id
            name
            description
            status  
            contactInfo {
              email
              phone
              website
            }
            created
            createdByUsername
            createdByUser {
                name
                givenName
                familyName
                email
            }
            updated       
            updatedByUsername
        }
}`;

export const purgeCustomer = `
    mutation purgeCustomer($input: PurgeCustomerInput!) {
        purgeCustomer(input:$input) 
}`;

export const deleteCustomer = `
    mutation deleteCustomer($input: DeleteCustomerInput!) {
        deleteCustomer(input:$input) 
}`;
